import React, { PureComponent } from 'react';
import DownIcon from 'mdi-react/ChevronDownIcon';
import { Collapse, Spinner } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Avatar from 'react-avatar';
import TopbarMenuLink from './TopbarMenuLink';
import { logout } from '../../../utils/auth';
import { resetAssets } from '../../../redux/actions/assetsActions';
import { resetParams } from '../../../redux/actions/paramsActions';
import { resetAccessesReceived } from '../../../redux/actions/accessReceivedActions';
import callDb from '../../../utils/server';

// const Ava = `${process.env.PUBLIC_URL}/img/ava.png`;

class TopbarProfile extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    user: PropTypes.shape({}).isRequired,
    params: PropTypes.shape({}).isRequired,
  };

  constructor() {
    super();
    this.state = {
      collapse: false,
      isLoading: false,
    };
  }

  toggle = () => {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  toggleIsLoading = () => {
    this.setState(prevState => ({ isLoading: !prevState.isLoading }));
  };

  /* eslint-disable consistent-return */
  signOut = () => {
    console.log('logging user out');
    const { isLoading } = this.state;
    if (isLoading) return false;
    const { dispatch, user } = this.props;
    const { idp, idToken } = user;
    dispatch(resetAssets());
    dispatch(resetParams());
    dispatch(resetAccessesReceived());
    if (idp === 'FC') {
      this.toggleIsLoading();
      console.log('must signout FranceConnect as well');
      callDb({ idToken }, 'auth_fc/get-logout-url').then((result) => {
        const { data } = result;
        console.log('returned logout FC data is: ', data);
        logout();
        if (data.path) {
          window.location = data.path;
        } else {
          console.log('error: not path for logout');
        }
      }).catch((err) => {
        console.log(err);
        logout();
      });
    } else {
      this.toggle();
      logout();
    }
  }

  render() {
    const { collapse, isLoading } = this.state;
    const { user, params } = this.props;

    return (
      <div className="topbar__profile">
        {
          params.isNewTrusted ? (
            <button className="topbar__avatar" type="button" onClick={this.toggle}>
              <img style={{ margin: 'auto 0', width: 32, height: 32 }} src={`${process.env.PUBLIC_URL}/img/logo/legitbee.png`} alt="logo_img" />
              {/* <Avatar style={{ margin: 'auto 0' }} size="36" round name={user.family_name} /> */}
              <p className="topbar__avatar-name">Bienvenue</p>
              <DownIcon className="topbar__icon" />
            </button>
          ) : (
            <button className="topbar__avatar" type="button" onClick={this.toggle}>
              <Avatar
                textSizeRatio={2.5}
                maxInitials={2}
                color="rgba(235,166,76,.2)"
                fgColor="#eba64C"
                style={{ margin: 'auto 0' }}
                size="36"
                round
                title={user.given_name ? `${user.given_name} ${user.family_name}` : 'En attente de validation...'}
                name={user.given_name ? `${user.given_name.charAt(0)} ${user.family_name && user.family_name.charAt(0)}` : '.'}
              />
              <p className="topbar__avatar-name">{user.gender === 'female' ? 'Mme' : 'M.'} {user.family_name}</p>
              <DownIcon className="topbar__icon" />
            </button>
          )
        }
        {collapse && <button className="topbar__back" type="button" onClick={this.toggle} />}
        <Collapse isOpen={collapse} className="topbar__menu-wrap">
          <div className="topbar__menu">
            {/* {!params.isNewTrusted && <TopbarMenuLink isTop={false} title="Mon compte" icon="user" path="/profile" onClick={this.toggle} />} */}
            <TopbarMenuLink isLink isTop={false} title="Aide" icon="question-circle" path="/information" onClick={this.toggle} />
            <div className="topbar__menu-divider" />
            <button className="topbar__link" type="button" onClick={this.signOut} disabled={isLoading}>
              {
                isLoading ? (
                  <Spinner className="mr-10" size="sm" role="status" aria-hidden="true" />
                ) : (
                  <span className="topbar__link-icon lnr lnr-exit" />
                )
              }
              <p className="topbar__link-title">Déconnexion</p>
            </button>
            {/* <TopbarMenuLink isTop={false} title="Déconnexion" icon="exit" path="/login" onClick={this.signOut} /> */}
          </div>
        </Collapse>
      </div>
    );
  }
}

export default connect(state => ({
  user: state.user,
  params: state.params,
}))(TopbarProfile);
